// Thin progress line across the top while reading a story.
import { $ } from "./dom.js";

export function initReadingBar({ signal } = {}) {
  const bar = $(".js-reading-bar");
  const article = $("article.article");
  if (bar) bar.style.width = "0";
  if (!bar || !article) return;

  const update = () => {
    const top = article.getBoundingClientRect().top + window.pageYOffset;
    const height = article.offsetHeight - window.innerHeight;
    const progress = height > 0 ? (window.pageYOffset - top) / height : 0;
    bar.style.width = Math.max(0, Math.min(1, progress)) * 100 + "%";
  };
  window.addEventListener("scroll", update, { passive: true, signal });
  window.addEventListener("resize", update, { signal });
  update();
}
